import { axiosClient } from "@/shared/api/axios-client";

/** Gestión Documental (fase 2) · tipos/subtipos de solicitud para configurar requisitos. */
export interface TipoDeSolicitudInfo {
  codigo: string;
  nombre: string;
  subtipos: { codigo: string; nombre: string }[];
}

export interface RequisitoDocumental {
  id: string;
  tipoSolicitud: string;
  subtipo: string;
  categoria: string;
  categoriaNombre: string;
  tipoDocumento: string | null;
  minimo: number;
  /** null = sin tope. */
  maximo: number | null;
  porCfdi: boolean;
  orden: number;
}

export interface CrearRequisitoInput {
  tipoSolicitud: string;
  subtipo: string;
  categoria: string;
  tipoDocumento: string | null;
  minimo: number;
  maximo: number | null;
  porCfdi: boolean;
  orden: number;
}

export interface EditarRequisitoInput {
  minimo: number;
  maximo: number | null;
  porCfdi: boolean;
  orden: number;
}

export type AmbitoRegla = "Area" | "Usuario";

export interface ReglaDeRevision {
  id: string;
  ambito: AmbitoRegla;
  referenciaId: string;
  nombreReferencia: string;
  requiereRevision: boolean;
  actualizadoAt: string;
}

const REQ = "/api/admin/requisitos-documentales";
const REGLAS = "/api/admin/reglas-revision-documental";

export const gestionDocumentalApi = {
  tiposDeSolicitud: () => axiosClient.get<TipoDeSolicitudInfo[]>(`${REQ}/tipos-solicitud`).then((r) => r.data),

  requisitos: (tipoSolicitud: string, subtipo: string) =>
    axiosClient.get<RequisitoDocumental[]>(REQ, { params: { tipoSolicitud, subtipo } }).then((r) => r.data),

  crearRequisito: (input: CrearRequisitoInput) => axiosClient.post<RequisitoDocumental>(REQ, input).then((r) => r.data),

  editarRequisito: (id: string, input: EditarRequisitoInput) =>
    axiosClient.put<RequisitoDocumental>(`${REQ}/${id}`, input).then((r) => r.data),

  eliminarRequisito: (id: string) => axiosClient.delete(`${REQ}/${id}`).then(() => undefined),

  reglas: () => axiosClient.get<ReglaDeRevision[]>(REGLAS).then((r) => r.data),

  guardarRegla: (ambito: AmbitoRegla, referenciaId: string, requiereRevision: boolean) =>
    axiosClient.put<ReglaDeRevision>(REGLAS, { ambito, referenciaId, requiereRevision }).then((r) => r.data),

  eliminarRegla: (id: string) => axiosClient.delete(`${REGLAS}/${id}`).then(() => undefined),
};
